// Calculates and formats read time based on blog body word count. 
// ex. wordTime(post.body.raw);

export const wordTime = (body) => {
  const count = Math.ceil(body?.split(" ")?.length / 300);
  return count > 1?count+" minutes":count+" minute";
}